export function isLocationData(obj) {
  return obj && obj.target && obj.detail;
}